import { CLINIC_BRAND } from "@/lib/brand";

export function BrandMark() {
	return <p className="font-mono text-sm uppercase tracking-widest text-info">{CLINIC_BRAND}</p>;
}
